require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./chronic-nuisance-property.json") })
        }
      }, "path---chronic-nuisance-property");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---chronic-nuisance-property!./.cache/json/chronic-nuisance-property.json
// module id = 851
// module chunks = 231608221292675